module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAAHUlEQVQ4y2N4+vSpHgMUUMIehGDUa6NeG/UaXQAAvERV5wGBupEAAAAASUVORK5CYII="